import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\git\\clients\\evergreen-strategy-website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
